import { render, staticRenderFns } from "./pageHeaderCard.vue?vue&type=template&id=9c3f90e8&scoped=true&"
import script from "./pageHeaderCard.vue?vue&type=script&lang=js&"
export * from "./pageHeaderCard.vue?vue&type=script&lang=js&"
import style0 from "./pageHeaderCard.vue?vue&type=style&index=0&id=9c3f90e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3f90e8",
  null
  
)

export default component.exports